import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

emailjs.init({
  publicKey: 'JMnfsN6W4IxijTb-H',
});

export default function Contact() {
  const form = useRef();
  const [status, setStatus] = useState('idle'); // 'idle' | 'sending' | 'success' | 'error'

  const sendEmail = (e) => {
    e.preventDefault();
    if (!form.current) return;

    setStatus('sending');

    emailjs.sendForm('service_xd7ai28', 'template_u9cj10l', form.current).then(
      () => {
        setStatus('success');
        try {
          form.current.reset();
        } catch (err) {
          /* ignore */
        }
      },
      () => {
        setStatus('error');
      }
    );
  };

  return (
    <section className="section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center" data-aos="fade-up">
            <span className="eyebrow">Contact</span>
            <h1 className="fw-900 mt-3 display-5">Discutons de votre projet</h1>
            <p className="text-secondary mt-3">
              Que ce soit pour un dépannage, un transfert vers la téléphonie IP ou un projet
              d'infrastructure complet — écrivez-nous, sans engagement.
            </p>
          </div>
        </div>

        <div className="row justify-content-center mt-4">
          <div className="col-lg-8" data-aos="fade-up">
            {status === 'success' && (
              <div className="alert alert-success text-center" role="alert">
                <h2 className="h5 fw-bold mb-1">Merci !</h2>
                <p className="mb-0">Le formulaire a été correctement envoyé. Nous vous recontacterons sous peu.</p>
              </div>
            )}

            {status === 'error' && (
              <div className="alert alert-danger text-center" role="alert">
                <h2 className="h5 fw-bold mb-1">Oups !</h2>
                <p className="mb-0">Quelque chose s'est mal passé... Merci de revenir un peu plus tard.</p>
              </div>
            )}

            {status !== 'success' && (
              <form ref={form} onSubmit={sendEmail} className="row g-3">
                <div className="col-md-6">
                  <label htmlFor="name" className="form-label">Nom</label>
                  <input id="name" name="name" type="text" className="form-control" required />
                </div>
                <div className="col-md-6">
                  <label htmlFor="mail" className="form-label">Courriel</label>
                  <input id="mail" name="mail" type="email" className="form-control" required />
                </div>
                <div className="col-md-6">
                  <label htmlFor="phone" className="form-label">Téléphone</label>
                  <input id="phone" name="phone" type="text" className="form-control" required />
                </div>
                <div className="col-md-6">
                  <label htmlFor="object" className="form-label">Objet</label>
                  <input id="object" name="object" type="text" className="form-control" required />
                </div>
                <div className="col-12">
                  <label htmlFor="message" className="form-label">Message</label>
                  <textarea id="message" name="message" rows="5" className="form-control" required></textarea>
                </div>

                <input type="hidden" name="to_email" value="info@cpucsolutions.com" />
                <input type="hidden" name="reply_to" value="no-reply@cpucsolutions.com" />

                <div className="col-12 text-center mt-2">
                  <button type="submit" className="btn btn-brand btn-lg rounded-pill px-5" disabled={status === 'sending'}>
                    {status === 'sending' ? 'Envoi...' : 'Envoyer'}
                  </button>
                </div>
              </form>
            )}

            <div className="text-center mt-4 text-secondary">
              <p className="mb-1">
                <i className="bi bi-envelope me-2 text-brand"></i>
                <a href="mailto:info@cpucsolutions.com">info@cpucsolutions.com</a>
              </p>
              <p className="mb-0">
                <i className="bi bi-telephone me-2 text-brand"></i>
                <a href="tel:4184767088">(418) 476-7088</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
